import { render, staticRenderFns } from "./ModalDataNote.vue?vue&type=template&id=3cb94dc2&scoped=true"
import script from "./ModalDataNote.vue?vue&type=script&lang=js"
export * from "./ModalDataNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb94dc2",
  null
  
)

export default component.exports